import React from 'react';
import { OptionIconProps } from '../../Popup/PopupOption';

export const AccountIcon: React.FC<OptionIconProps> = ({
  disabled = false,
}): JSX.Element => {
  const color = disabled ? '#E0E2EE' : '#4D4558';
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_211_545" fill="white">
        <path d="M2.6665 11.9642C2.6665 10.0738 4.19897 8.54138 6.08936 8.54138H9.91031C11.8007 8.54138 13.3332 10.0738 13.3332 11.9642C13.3332 12.7204 12.7202 13.3334 11.964 13.3334H4.03565C3.27949 13.3334 2.6665 12.7204 2.6665 11.9642Z" />
      </mask>
      <path
        d="M6.08936 9.54138H9.91031V7.54138H6.08936V9.54138ZM11.964 12.3334H4.03565V14.3334H11.964V12.3334ZM4.03565 12.3334C3.83177 12.3334 3.6665 12.1681 3.6665 11.9642H1.6665C1.6665 13.2727 2.72721 14.3334 4.03565 14.3334V12.3334ZM12.3332 11.9642C12.3332 12.1681 12.1679 12.3334 11.964 12.3334V14.3334C13.2725 14.3334 14.3332 13.2727 14.3332 11.9642H12.3332ZM9.91031 9.54138C11.2484 9.54138 12.3332 10.6261 12.3332 11.9642H14.3332C14.3332 9.52156 12.353 7.54138 9.91031 7.54138V9.54138ZM6.08936 7.54138C3.64668 7.54138 1.6665 9.52156 1.6665 11.9642H3.6665C3.6665 10.6261 4.75125 9.54138 6.08936 9.54138V7.54138Z"
        fill={color}
        mask="url(#path-1-inside-1_211_545)"
      />
      <path
        d="M10.2829 5.43904C10.2829 6.69229 9.26263 7.71145 8.0001 7.71145C6.73757 7.71145 5.71729 6.69229 5.71729 5.43904C5.71729 4.18578 6.73757 3.16663 8.0001 3.16663C9.26263 3.16663 10.2829 4.18578 10.2829 5.43904Z"
        stroke={color}
      />
    </svg>
  );
};
